import { CheckIcon } from '@/assets/Check';
import { EditChevron } from './EditChevron';
import { EmailDrawer } from '@/components/EmailDrawer';
import { Card } from '@/components/ui/card';
import { userInfo } from '@/store/selectors/user';
import { t } from 'i18next';

import { useState } from 'react';
import { useSelector } from 'react-redux';

export const EmailInfo = () => {
  const user = useSelector(userInfo);
  const [emailOpen, setEmailOpen] = useState(false);

  return (
    <>
      <div className="flex flex-col gap-1">
        <Card
          className="flex flex-col rounded-xl pl-4 py-[11px]"
          onClick={() => setEmailOpen(true)}
        >
          <div className="flex flex-row items-center justify-between">
            <div className="flex flex-col">
              <p className="text-body-base-regular text-text-primary">E-mail</p>
              {user?.email && (
                <p className="text-body-sm-regular text-text-tertiary">
                  {user.email}
                </p>
              )}
            </div>
            <div className="flex flex-row items-center gap-2 pr-4">
              {user?.email ? (
                <CheckIcon className="text-brand-green" />
              ) : (
                <p className="text-body-base-regular text-brand-green">
                  {t('specify')}
                </p>
              )}
              <EditChevron />
            </div>
          </div>
        </Card>
        {/* {user?.email && (
          <p className="text-xs text-gray-300 px-4">
            {user.verifiedEmail
              ? 'Почта подтверждена. Подтверждение почты необходимо для службы поддержки'
              : 'Подтверждение почты необходимо для службы поддержки'}
          </p>
        )} */}
      </div>

      <EmailDrawer open={emailOpen} setOpen={setEmailOpen} />
    </>
  );
};
